import { Box } from '@mui/material';

interface AgencyLogoProps {
  agencyLogo: string | undefined;
  width?: string;
  height?: string;
}

const AgencyLogo = ({
  agencyLogo,
  width = '243px',
  height = '147px'
}: AgencyLogoProps) => {
  return (
    <Box
      sx={{
        aspectRatio: '5/3',
        height,
        width,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fefefe',
        borderRadius: '10px',
        padding: '4px 0',
        overflow: 'hidden'
      }}
    >
      <Box
        component="img"
        src={agencyLogo}
        alt="Agency Logo"
        sx={{
          height: '100%',
          width: '100%',
          margin: 'auto',
          padding: '12px',
          objectFit: 'contain'
        }}
      />
    </Box>
  );
};

export default AgencyLogo;
